import logo from './logo.svg';
import './App.css';
import {useEffect, useMemo, useRef, useState} from "react";
import AlertError from "./components/AlertError";
import background from "./assets/image.png"
import HeadPhone from "./components/HeadPhone";
import banner from "./assets/banner.png"
import ButtonIcon from "./components/icons/ButtonIcon";
import MicroIcon from "./components/icons/MicroIcon";
import CameraIcon from "./components/icons/CameraIcon";
import {Caller} from "call-services";
import {useCountTime} from "./hooks/useCountTime";
import DialogOTP from "./components/DialogOTP";
import VideoStream from "./components/VideoStream";
import EndCall from "./components/EndCall";
import {Ping} from "./components/Ping/Ping";
import clsx from "clsx";
import DialogConfirm from "./components/DialogConfirm";
import {getCallInfo, setCustomerAction} from "./services";
import MuteIcon from "./components/icons/MuteIcon";
import {ENV} from "./constants";
import LoadingDot from "./components/LoadingDot";
import {useOTP} from "./hooks/useOTP";

const MESSAGES = {
    busy: "Xin lỗi Quý khách, hiện tất cả các tổng đài viên đều đang bận hoặc hết giờ hỗ trợ. Quý khách vui lòng gọi lại trong khung giờ 8h-22h. Cám ơn Quý khách!",
    devices: "Quý khách cần cho phép truy cập  Camera và Microphone tại “Cài đặt” trên thiết bị để có thể tham gia cuộc gọi video.",
    not_connected: "Mất kết nối. Quý khách vui lòng thử lại sau"
}

function App() {
    const [token, setToken] = useState();
    const [apiToken, setApiToken] = useState();
    const [status, setStatus] = useState();
    const [connected, setConnected] = useState(false);
    const [alert, setAlert] = useState();
    const [confirm, setConfirm] = useState();
    const [time, start, stop] = useCountTime();
    const [openOtp, setOpenOtp] = useState(false);
    const [localVideo, setLocalVideo] = useState()
    const [remoteVideo, setRemoteVideo] = useState()
    const [isMute, setIsMute] = useState(false);
    const [verified, setVerified] = useState(false);
    const [customer, setCustomer] = useState()
    const [loading, setLoading] = useState(false);
    const [isEndCall, setEndCall] = useState(false);
    const [height, setHeight] = useState(0);
    const [isCall, setCall] = useState(false);
    const [streamConnect, setStreamConnect] = useState(false);
    const [callError, setCallError] = useState(false);
    const variableRef = useRef(connected);
    const [camFront,setCamFront] = useState(true)

    useEffect(() => {
        variableRef.current = connected;
    }, [connected]);
    // useBeforeunload(() => {
    //     if (navigator.serviceWorker.controller) {
    //         // navigator.serviceWorker.controller.postMessage({token, description: "close tab", env: ENV});
    //     }
    // });
    // useEffect(() => {
        // let startY;
        //
        // document.addEventListener('touchstart', function(event) {
        //     startY = event.touches[0].clientY;
        // }, { passive: true });
        // const handleTouchMove = (event) => {
        //     const currentY = event.touches[0].clientY;
        //     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //     const maxScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        //
        //     // Điều kiện khi kéo xuống từ đầu trang hoặc kéo lên từ cuối trang
        //     if ((scrollTop === 0 && currentY > startY) || (scrollTop === maxScroll && currentY < startY)) {
        //         event.preventDefault();
        //     }
        // };
        // document.addEventListener('touchmove', handleTouchMove, {passive: false});
        // return () => {
        //     document.removeEventListener('touchmove', handleTouchMove);
        // };
    // }, []);
    useEffect(() => {
        setInterval(() => {
            const height = window.innerHeight;
            setHeight(height)
        }, 100);
    }, []);
    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const t = params.get('s');
        const api = params.get('t');
        setApiToken(api);
        setToken(t);
    }, []);
    const caller = useMemo(() => {
        if (token) {
            const search = window.location.search;
            const params = new URLSearchParams(search);
            const requestId = params.get('r');
            return new Caller(token, "VIDEO", {isLog: true, requestId, env: ENV})
        }
    }, [token])
    useEffect(() => {
        if (apiToken) {
            getCallInfo(apiToken).then((data) => {
                if (data && !data.errorCode) {
                    setCustomer(data)
                } else {
                    setEndCall(true);
                    setCallError(data);
                }
            }).catch(e => {
                setEndCall(true);
                setCallError(e);
            })
        }
    }, [apiToken])
    useEffect(() => {
        if (callError && caller) {
            caller.showLog(`Client call error ${JSON.stringify(callError)}`);
        }
    }, [callError, caller]);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (!variableRef.current) {
                caller?.showLog("client not connect socket")
            }
        }, 5000);
        return () => clearTimeout(timer);
    }, [caller]);
    useEffect(() => {
        if (caller && connected && !isEndCall && customer && !isCall) {
            caller.showLog(`Customer: ${JSON.stringify(customer)}`);
            makeCall()
        }
    }, [caller, connected, isEndCall, customer, isCall])
    useEffect(() => {
        if (!isEndCall) {
            caller?.showLog("client end call")
        }
    }, [isEndCall]);
    const onCloseAlert = () => {
        setAlert(undefined);
        setEndCall(true)
    }
    useEffect(() => {
        if (status === "CONNECT") {
            start();
        }
    }, [status]);
    useEffect(() => {
        if (caller) {
            caller.onChangeStatus(s => {
                if (s === "BUSY" && !alert) {
                    setAlert({message: MESSAGES.busy, onClose: onCloseAlert})
                }
                if (s === "DISCONNECT" && !alert) {
                    setEndCall(true)
                    setAlert({message: MESSAGES.not_connected, onClose: onCloseAlert})
                }
                setStatus(s);
            })
            caller.onStreamConnect(setStreamConnect)
            caller.onConnect((connect) => {
                setConnected(connect);
            });
        }
    }, [caller]);
    useEffect(() => {
        if (caller && localVideo && remoteVideo) {
            caller.addVideoElement(localVideo, remoteVideo)
        }
    }, [caller, localVideo, remoteVideo]);
    const makeCall = () => {
        if (!connected) {
            setAlert({message: MESSAGES.not_connected, onClose: onCloseAlert})
        }
        setCall(true);
        setLoading(true);
        caller?.makeCall().then(() => {
            setLoading(false);
            const dataChanel = caller?.dataChanel;
            dataChanel?.onmessage(event => {
                if (event.data === "verify") {
                    setOpenOtp(true);
                }
            })
        }).catch((e) => {
            console.log(e);
            if (e.code === "devices") {
                setStatus("READY");
                setCustomerAction(apiToken, "MEDIA_PERMISSION_DENIED").then();
                setAlert({message: MESSAGES.devices, onClose: onCloseAlert});
            }
            if (e.code === "not_connected") {
                setAlert({message: MESSAGES.not_connected, onClose: onCloseAlert});
            }
        })
    }
    useEffect(() => {
        if (connected === false && status && status === "REQUEST") {
            setAlert({message: MESSAGES.not_connected, onClose: onCloseAlert});
        }
    }, [connected, status]);
    const endCall = () => {
        if (status === "REQUEST") {
            caller?.cancelCall().then()
        } else {
            caller?.endCall().then()
        }
        setEndCall(true)
    }
    const handleEndCall = () => {
        if (!verified) {
            setConfirm(true)
        } else {
            endCall()
        }
    }
    const handleMute = () => {
        caller?.mute();
        setIsMute(!isMute);
    }
    const turnVideo =()=>{
        caller?.turnVideo()
        setCamFront(!camFront);
    }
    if (!status || status === "START") {
        return (
            <div
                style={{height: height ? height : "auto"}}
                className={clsx("bg-black overflow-hidden w-screen h-screen flex flex-col items-center justify-center")}>
                <HeadPhone/>
                <div className="text-white">Đang tải ...</div>
                {/*<DialogOTP token={apiToken} openAlert={setAlert} open={true} data={customer}*/}
                {/*           onClose={() => setOpenOtp(false)}/>*/}
            </div>
        )
    }
    if (status === "END_CALL" || isEndCall) {
        return <EndCall verified={verified}/>
    }
    return (
        <>
            {/*{(status === "READY" && isCall) && (*/}
            {/*    <StartCall makeCall={makeCall} loading={loading}/>*/}
            {/*)}*/}
            <div
                style={{height: height ? height : "auto"}}
                className={clsx("bg-black overflow-hidden w-screen h-screen flex flex-col items-center touch-none")}>
                <div className="flex flex-1 flex-col w-full h-full justify-center items-center relative">
                    {(status !== "CONNECT") && (
                        <>
                            {/*<img src={background} className="absolute w-full h-full object-contain" alt=""/>*/}
                            <HeadPhone/>
                            {status === "REQUEST" &&
                                <div className="text-sm text-slate-100 relative pt-4">Đang kết nối tới chuyên
                                    viên...</div>}
                            {status === "DISCONNECT" &&
                                <div className="text-sm text-red-600 relative text-center pt-4">Mất kết nối</div>}
                        </>
                    )}
                    {status === "CONNECT" && (
                        <div className="text-sm text-slate-100 absolute z-40 flex items-center top-12 pb-4">
                            <Ping/>
                            {time}
                        </div>
                    )}
                    {status === "CONNECT" && !streamConnect && (
                        <div className="absolute z-[100]">
                            <LoadingDot label="Đang kết nối lại"/>
                        </div>
                    )}
                    <VideoStream setLocal={setLocalVideo} isFront={camFront} setRemote={setRemoteVideo} connected={status === "CONNECT"}/>
                </div>
                {status !== "CONNECT" && (<img src={banner} alt="vpbank" className="relative max-w-xs pt-2 mx-4"/>)}
                <div className="flex justify-center w-full bg-black relative z-20 items-center">
                    <div className="py-6 flex justify-center items-center">
                        {status !== "READY" && (
                            <>
                                <ButtonIcon onClick={handleMute}>
                                    {isMute ? <MuteIcon/> : <MicroIcon/>}
                                </ButtonIcon>
                                <ButtonIcon className="ml-4" onClick={caller?.turnVideo}><CameraIcon/></ButtonIcon>
                                <button className="bg-red-600 py-4 px-6 rounded-full text-white ml-4"
                                        onClick={handleEndCall}>
                                    Kết thúc
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <AlertError open={Boolean(alert)} message={alert?.message} onClose={alert?.onClose}/>
                <DialogOTP token={apiToken} openAlert={setAlert} open={openOtp} data={customer}
                           onClose={() => setOpenOtp(false)}/>
                <DialogConfirm open={confirm} onSubmit={endCall}
                               message="Quý khách có chắc chắn muốn kết thúc cuộc gọi video ?"
                               onClose={() => setConfirm()}/>
            </div>
        </>
    );
}

export default App;
